import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUser } from '../../providers/UserContext';
import { functions } from '../../firebase';
import { httpsCallable } from 'firebase/functions';
import axios from 'axios';
import { Modal, Button } from 'antd';
import LoadingScreen from '../LoadingScreen/LoadingScreen';

import './Plans.css';

const Plans = () => {
  const { t } = useTranslation();
  const [modalVisible, setModalVisible] = useState(false);
  const [modalNeedLogin, setModalNeedLoginVisible] = useState(false);
  const { user } = useUser();
  console.log(user)
  const [activePlan, setActivePlan] = useState(user ? user.is_premium ? "2" : "1" : "1"); // Por defecto será el basic plan.
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);



  const apiUrl = process.env.REACT_APP_API_URL;

  const plansOptions = [
    {
      id: '1',
      title: t('basicPlan'),
      description: t('plansList.basicList', { returnObjects: true }),
      imgSrc: '../../../assets/images/BasicPlan_Image.jpg',
      price: t('basicPrice')
    },
    {
      id: '2',
      title: t('premiumPlan'),
      description: t('plansList.premiumList', { returnObjects: true }),
      imgSrc: '../../../assets/images/PremiumPlan_Image.jpg',
      price: t('premiumPrice')
    },
  ];

  useEffect(() => {
    const fetchUser = async () => {
      if (user) {
        try {
          const collection = 'user';
          var userUID = user.uid ? user.uid : localStorage.getItem("userUID")
          const response = await axios.get(`${apiUrl}/collections/${collection}/${userUID}`);
          setUsuario(response.data);
          if (response.data.is_premium) {
            setActivePlan('2');
          } else {
            setActivePlan('1');
          }
          setLoading(false); // Solo se ejecutará una vez cuando se cargue el usuario
        } catch (error) {
          console.error('Error fetching user data:', error);
        } finally {
          setLoading(false);  // Asegurarse de que loading sea falso al finalizar
        }
      } else {
        setLoading(false);  // Para los casos en los que no hay usuario, finalizamos el loading
      }
    };

    fetchUser();
  }, [user]);

  const handlePlanChange = (planId) => {
    if (planId === '2' && activePlan !== '2') {
      setModalVisible(true); // Mostrar modal si selecciona premium
    }

    if (planId === '1' && activePlan === '2') {
      // Mostrar confirmación de cancelación si ya es premium y selecciona basic
      setShowCancelConfirmation(true);
    }
  };


  const handlePayment = async () => {
    if (user){
      try {
        const { data } = await axios.post(`${apiUrl}/collections/create-checkout-session`, {
          userId: user.uid,
          userMail: user.email
        });
        window.location.href = data.url; // Redirigir a Stripe Checkout
      } catch (error) {
        console.error('Error iniciando la sesión de pago:', error);
      }
    }else{
      setModalNeedLoginVisible(true); // Abre el modal need login
    }
  };

  const handleConfirmCancelSubscription = async () => {
    try {
      const response = await axios.post(`${apiUrl}/collections/cancel-subscription`, {
        email: user.email,
        id_negocio: usuario.id_negocio,
        is_premium: false,
        stripeId: usuario.stripeId
      });

      if (response.status === 200) {
        setShowCancelConfirmation(false);
        setShowSuccessModal(true); // Mostrar modal de éxito
        sendPremiumCancellationEmail(user.email, user.displayName);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        console.error('Error al anular la suscripción:', response);
      }
    } catch (error) {
      console.error('Error al hacer la solicitud:', error);
    }
  };


  const handleCloseModal = () => {
    setModalVisible(false); // Cierra el modal
  };

  const handleCloseModalNeedLogin = () => {
    setModalNeedLoginVisible(false); // Cierra el modal
  };

  if (loading) {
    return <LoadingScreen setLoadingComplete={setLoading} />;
  }

  const sendPremiumCancellationEmail = async (email, displayName) => {
    try {
      console.log("MANDANDO MAIL DE CANCELACIÓN PREMIUM");
      const sendWelcomeEmail = httpsCallable(functions, 'sendWelcomeEmail');

      const logoUrl = 'https://reveat.pro/assets/images/RevEat_Logo_PNG.png';
      const reveatYellow = getComputedStyle(document.documentElement).getPropertyValue('--reveat-yellow').trim();

      // Plantilla HTML del correo
      const htmlContent = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Cancelación de Cuenta Premium</title>
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1">
          <meta http-equiv="X-UA-Compatible" content="IE=edge" />
          <style type="text/css">
                  @media screen {
                      @font-face {
                          font-family: 'Lato';
                          font-style: normal;
                          font-weight: 400;
                          src: local('Lato Regular'), local('Lato-Regular'), url(https://fonts.gstatic.com/s/lato/v11/qIIYRU-oROkIk8vfvxw6QvesZW2xOQ-xsNqO47m55DA.woff) format('woff');
                      }
                      @font-face {
                          font-family: 'Lato';
                          font-style: normal;
                          font-weight: 700;
                          src: local('Lato Bold'), local('Lato-Bold'), url(https://fonts.gstatic.com/s/lato/v11/qdgUG4U09HnJwhYI-uK18wLUuEpTyoUstqEm5AMlJo4.woff) format('woff');
                      }
                      @font-face {
                          font-family: 'Lato';
                          font-style: italic;
                          font-weight: 400;
                          src: local('Lato Italic'), local('Lato-Italic'), url(https://fonts.gstatic.com/s/lato/v11/RYyZNoeFgb0l7W3Vu1aSWOvvDin1pK8aKteLpeZ5c0A.woff) format('woff');
                      }
                      @font-face {
                          font-family: 'Lato';
                          font-style: italic;
                          font-weight: 700;
                          src: local('Lato Bold Italic'), local('Lato-BoldItalic'), url(https://fonts.gstatic.com/s/lato/v11/HkF_qI1x_noxlxhrhMQYELO3LdcAZYWl9Si6vvxL-qU.woff) format('woff');
                      }
                  }
                  body, table, td, a { -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }
                  table, td { mso-table-lspace: 0pt; mso-table-rspace: 0pt; }
                  img { -ms-interpolation-mode: bicubic; }
                  img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; }
                  table { border-collapse: collapse !important; }
                  body { height: 100% !important; margin: 0 !important; padding: 0 !important; width: 100% !important; }
                  a[x-apple-data-detectors] { color: inherit !important; text-decoration: none !important; font-size: inherit !important; font-family: inherit !important; font-weight: inherit !important; line-height: inherit !important; }
                  @media screen and (max-width:600px) { h1 { font-size: 32px !important; line-height: 32px !important; } }
                  div[style*="margin: 16px 0;"] { margin: 0 !important; }
              </style>
        </head>
        <body style="background-color: #f4f4f4; margin: 0 !important; padding: 0 !important;">
          <table border="0" cellpadding="0" cellspacing="0" width="100%">
            <tr>
              <td bgcolor="${reveatYellow}" align="center">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">
                  <tr>
                    <td align="center" valign="top" style="padding: 40px 10px 40px 10px;">
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td bgcolor="${reveatYellow}" align="center" style="padding: 0px 10px 0px 10px;">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">
                  <tr>
                    <td bgcolor="#ffffff" align="center" valign="top" style="padding: 40px 20px 20px 20px; border-radius: 4px 4px 0px 0px; color: #111111; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 48px; font-weight: 400; line-height: 48px;">
                      <h1 style="font-size: 48px; font-weight: 400; margin: 2;">Hola ${displayName}, lamentamos verte ir...</h1>
                      <img src="${logoUrl}" width="160" height="120" style="display: block; border: 0px; margin : 30px 20px 20px 20px" />
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td bgcolor="#f4f4f4" align="center" style="padding: 0px 10px 0px 10px;">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">
                  <tr>
                    <td bgcolor="#ffffff" align="left" style="padding: 20px 30px 40px 30px; color: #666666; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; line-height: 25px;text-align:center">
                      <p style="margin: 0;">Has cancelado tu cuenta Premium en Reveat. A partir de ahora, tu cuenta volverá a ser <b>Prueba Gratuita por 7 días</b>, lo que significa que tendrás acceso limitado a las funcionalidades:</p>
                      <p style="margin: 0;"><b>Ahora:</b><br><br>
                        - Podrás ver informes limitados a 2.<br>
                        - No tendrás acceso completo a las gráficas comparativas con otros negocios.<br>
                        - Algunas funciones avanzadas estarán restringidas.
                      </p>
                      <p style="margin: 0;">Si decides volver a Premium, siempre estaremos aquí para recibirte de nuevo.</p>
                    </td>
                  </tr>
                  <tr>
                    <td bgcolor="#ffffff" align="center" style="padding: 20px 30px 60px 30px;">
                      <a href="${window.location.origin}/dashboard" target="_blank" style="font-size: 20px; font-family: Helvetica, Arial, sans-serif; color: #ffffff; text-decoration: none; padding: 15px 25px; border-radius: 20px; background-color: ${reveatYellow}; border: 1px solid ${reveatYellow};">Accede a tu Dashboard</a>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td bgcolor="#f4f4f4" align="center" style="padding: 30px 10px 0px 10px;">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">
                  <tr>
                    <td bgcolor="#FFFFFF" align="center" style="padding: 30px 30px 30px 30px; border-radius: 4px 4px 4px 4px; color: #666666; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; line-height: 25px;">
                      <h2 style="font-size: 20px; font-weight: 400; color: #111111; margin: 0;">¿Tienes alguna pregunta?</h2>
                      <p style="margin: 0;"><a href="${window.location.origin}/faq" target="_blank" style="color: ${reveatYellow};">Estamos aquí para ayudarte</a></p>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </body>
        </html>
      `;

      const result = await sendWelcomeEmail({
        to: email,
        subject: `Confirmación de cancelación de cuenta Premium, ${displayName}`,
        text: `Hola ${displayName}, lamentamos que hayas cancelado tu cuenta Premium. Si decides volver, siempre estaremos aquí.`,
        html: htmlContent
      });

      console.log('Email de confirmación de cancelación enviado:', result.data);
    } catch (error) {
      console.error('Error al enviar el email de cancelación:', error);
    }
  };


  return (
    <div className="plans-container">
      <div className='footer-margin'>
      <div className="row">
        {plansOptions.map((plan) => (
          <div key={plan.id} className={`card mx-2 mb-4`}
            style={{
              borderWidth: activePlan === plan.id ? '4px' : '0px',
              borderColor: activePlan === plan.id ? getComputedStyle(document.documentElement).getPropertyValue('--reveat-yellow').trim() : '#ddd',
              borderStyle: 'solid',
              borderRadius: '15px'
            }}>
            <img className="card-img-top" src={plan.imgSrc} alt={plan.title} />
            <div className="card-body">
              <h5 className="card-title pt-1 mb-2">
                {plan.title} {activePlan === plan.id ? t('currentPlan') : ''}
              </h5>
              <div className="card-description">
                <ul className="list-unstyled">
                  {plan.description.map((item, index) => (
                    <li key={index}>
                      {plan.id === '1' && index % 2 !== 0 ? (
                        <i className='ph-x'
                          style={{
                            color: 'red',
                            fontSize: '20px',
                            marginRight: '10px',
                          }} />
                      ) : (
                        <i className='ph-check'
                          style={{
                            color: 'green',
                            fontSize: '24px',
                            marginRight: '10px',
                          }} />
                      )}
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="card-footer">
              <button className="d-inline-flex align-items-center ms-auto btn btn-basic"
                onClick={() => handlePlanChange(plan.id)}>
                {plan.price}<i className="ph-arrow-circle-right ms-2"></i>
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal de confirmación */}
      <Modal
        visible={modalVisible}
        onCancel={handleCloseModal}
        footer={null}
        title={t('paymentConfirmationTitle')}
      >
        <p>{t('paymentConfirmationMessage')}</p>
        <div className='paymentButton'>
          <Button variant="primary" className='custom-btn' onClick={handlePayment}>
            {t('proceedToPayment')}
          </Button>
        </div>
      </Modal>

      <Modal
        visible={modalNeedLogin}
        onCancel={handleCloseModalNeedLogin}
        footer={null}
        title={t('needLoginTitle')}
      >
        <p>{t('needLoginMessage')}</p>
      </Modal>

      <Modal
        visible={showCancelConfirmation}
        onCancel={() => setShowCancelConfirmation(false)}
        footer={[
          <Button className='cancel-cancel-subscription' key="cancel" onClick={() => setShowCancelConfirmation(false)}>
            {t('no')}
          </Button>,
          <Button className='confirm-cancel-subscription' key="confirm" type="primary" onClick={handleConfirmCancelSubscription}>
            {t('yesCancelSubscription')}
          </Button>,
        ]}
        title={t('cancelSubscriptionTitle')}
      >
        <p>{t('cancelSubscriptionMessage')}</p>
      </Modal>

      <Modal
        visible={showSuccessModal}
        onCancel={() => setShowSuccessModal(false)}
        footer={null}
        title={t('subscriptionCanceledTitle')}
      >
        <p>{t('subscriptionCanceledMessage')}</p>
      </Modal>
    </div>
    </div>
  );
};

export default Plans;
